module.exports = __webpack_public_path__ + "static/media/motor-yacht-big.15f99c3b.svg";